<!-- <div class="match-chat-header" *ngIf="data.from_tennis_match">
<h2 class="chat-title" *ngIf="!is_livestream">{{ handleChatTitle() }}</h2>
</div> -->

@if ((sponsor | keyvalue)?.length) {
  <div class="match-sponsor">
    @if (video_ad_sponsor) {
      <app-rotating-sponsors [video_ad_sponsor]="video_ad_sponsor" [sponsor_id]="sponsor.id" [default_aspect_ratio]="'9:1'"></app-rotating-sponsors>
    } @else {
      <app-rotating-sponsors [sponsor_id]="sponsor.id" [default_aspect_ratio]="'9:1'"></app-rotating-sponsors>
    }
  </div>
}

<!-- <div class="chat-welcome" *ngIf="data.from_tennis_match || show_welcome">
<app-app-string [key_name]="'golfchat.welcome'"></app-app-string>
</div> -->

@if (is_livestream) {
  <h2 class="chat-title" style="margin: 0">{{ handleChatTitle() }}</h2>
}

@if (ready()) {
  <lib-bleachr-chat
    class="chat"
    [host_url]="hostUrl"
    [subject_id]="subjectID"
    [chat_type]="subjectType"
    [subject_name]="subjectName"
    [fingerprint]="fingerprint"
    [token]="chatToken"
    [app_string_url]="appStringUrl"
    [spoiler_free_mode]="spoiler_free_toggle"
    [chatbox_height]="chatbox_height"
    [chatbox_width]="chatbox_width"
    [elixir_url]="elixirUrl"
    [type_limits]="chat_type_limits"
    [sponsor_id]="sponsor_key"
    [identifier]="accountAdentifier"
  ></lib-bleachr-chat>
}
